// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"Drawer_SideDrawer__2lMHi","Open":"Drawer_Open__2y_gZ","Closed":"Drawer_Closed__17_M7"};